enum SubscriptionStatus {
  Unknown = 0,
  // Missing = 1, // Obsolete : leading to confusion with NotSubscribed
  Subscribed = 2,
  NotSubscribed = 3
}

export default SubscriptionStatus;
